import { useFlags } from "launchdarkly-react-client-sdk";
import { FEATURE_FLAGS } from "./utils";

export type FeatureFlagStatus = {
  [key in FEATURE_FLAGS]: boolean;
};

type FeatureFlagInput = FEATURE_FLAGS | FEATURE_FLAGS[];

// Function overloads for single and multiple flags
interface UseLaunchDarklyFlags {
  (featureFlagNames: FEATURE_FLAGS): boolean;
  (featureFlagNames: FEATURE_FLAGS[]): FeatureFlagStatus;
}

const useLaunchDarklyFlags = ((featureFlagNames: FeatureFlagInput) => {
  const flags = useFlags();

  // Check if featureFlagNames is an array or a single value
  if (Array.isArray(featureFlagNames)) {
    const flagStatuses = featureFlagNames.reduce((acc, featureName) => {
      const flagName =
        featureName in FEATURE_FLAGS ? FEATURE_FLAGS[featureName] : featureName;
      acc[flagName] = flags ? flags[flagName] : false;

      return acc;
    }, {} as FeatureFlagStatus);

    return flagStatuses;
  } else {
    // Handle single flag
    const flagName =
      featureFlagNames in FEATURE_FLAGS
        ? FEATURE_FLAGS[featureFlagNames]
        : featureFlagNames;

    return flags ? flags[flagName] : false;
  }
}) as UseLaunchDarklyFlags;

export default useLaunchDarklyFlags;
